module.exports = __webpack_public_path__ + "static/media/8OLA29.2c0a664a.jpg";